// src/CreditCard.tsx
import * as React from "react";
var CreditCard = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M15.6 2.4H4.4c-.78 0-1.39.62-1.39 1.4L3 12.2c0 .78.62 1.4 1.4 1.4h11.2c.78 0 1.4-.62 1.4-1.4V3.8c0-.78-.62-1.4-1.4-1.4zm-.7 9.8H5.1c-.38 0-.7-.31-.7-.7V8h11.2v3.5c0 .39-.32.7-.7.7zm.7-7H4.4V3.8h11.2v1.4z" })
);
CreditCard.displayName = "CreditCard";
export {
  CreditCard
};
